(function () {
  if (window.__cartCsBound) return;
  window.__cartCsBound = true;

  function block(el) { return el.closest('[data-cart-cross-sell]'); }
  function slides(b) { return Array.from(b.querySelectorAll('[data-cs-slide]')); }

  function activeIndex(sl) {
    for (var i = 0; i < sl.length; i++) {
      if (sl[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function goTo(b, index) {
    var sl = slides(b);
    if (index < 0 || index >= sl.length) return;
    sl.forEach(function (s, i) {
      var on = i === index;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    var prev = b.querySelector('[data-cs-prev]');
    var next = b.querySelector('[data-cs-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === sl.length - 1;
  }

  // Récupère les sections à rafraîchir auprès du thème (même mécanisme que le module PDP)
  function getBundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function publishCartUpdate(cart) {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      // open:false → le tiroir se re-render sans s'ouvrir/refermer.
      // Au re-render, le snippet Liquid ré-évalue la règle et exclut le produit ajouté.
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-cross-sell',
        cart: cart,
        open: false
      });
    }
  }

  document.addEventListener('click', function (e) {
    // ── Carousel : précédent ──
    var prevBtn = e.target.closest('[data-cs-prev]');
    if (prevBtn) {
      var bp = block(prevBtn);
      if (bp) goTo(bp, activeIndex(slides(bp)) - 1);
      return;
    }

    // ── Carousel : suivant ──
    var nextBtn = e.target.closest('[data-cs-next]');
    if (nextBtn) {
      var bn = block(nextBtn);
      if (bn) goTo(bn, activeIndex(slides(bn)) + 1);
      return;
    }

    // ── Sélection de couleur ──
    var sw = e.target.closest('[data-cs-swatch]');
    if (sw) {
      var swCard = sw.closest('[data-cs-card]');
      if (!swCard) return;
      swCard.querySelectorAll('[data-cs-swatch]').forEach(function (s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('is-selected');
      sw.setAttribute('aria-pressed', 'true');

      var priceEl = swCard.querySelector('[data-cs-price]');
      if (priceEl && sw.dataset.variantMoney) priceEl.textContent = sw.dataset.variantMoney;

      var mainImg = swCard.querySelector('[data-cs-main-image]');
      if (mainImg && sw.dataset.variantImage) mainImg.src = sw.dataset.variantImage;

      var titleEl = swCard.querySelector('[data-cs-variant-title]');
      if (titleEl && sw.dataset.variantTitle) titleEl.textContent = sw.dataset.variantTitle;
      return;
    }

    // ── Ajout au panier ──
    var atc = e.target.closest('[data-cs-atc]');
    if (!atc || atc.disabled) return;
    e.preventDefault();

    var card = atc.closest('[data-cs-card]');
    var sel  = card ? card.querySelector('[data-cs-swatch].is-selected') : null;

    var variantId    = sel ? sel.dataset.variantId : atc.dataset.variantId;
    var variantPrice = parseFloat((sel ? sel.dataset.variantPrice : atc.dataset.variantPrice) || '0');
    if (!variantId) return;

    atc.disabled = true;
    atc.classList.add('is-loading');

    if (window.gtag) {
      gtag('event', 'cart_cross_sell_add_to_cart', {
        event_category: 'Cart cross-sell',
        event_label: variantId,
        currency: 'EUR',
        value: variantPrice
      });
    }

    var sections = getBundledSections();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: sections })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status) { throw item; } // sold out / error
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (item.sections) cart.sections = item.sections;
            return cart;
          });
      })
      .then(function (cart) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-cross-sell',
          cart: cart,
          open: false
        });
      })
      .catch(function () {
        atc.disabled = false;
        atc.classList.remove('is-loading');
      });
  });
})();